import React, {useState} from "react"
import FieldProto from "../../../../../proto/field-proto"
import {FieldViewSize} from "../../../../../const";

type Props = {
    className?  : string
    field       : FieldProto
    value       : any
    disabled?   : boolean
    options     : any
    onClick     : callback      // open dropdown
    onReset?    : callback      // open dropdown
    children    : any
}


export default function FieldDatetime_FormValueNotEmpty(props:Props) {

    const size : FieldViewSize = _.get(props, 'size', FieldViewSize.DEFAULT)

    const [isHovered, setIsHovered] = useState(false)

    const onMouseEnter = () => {
        if (!isHovered) setIsHovered(true)
    }

    const onMouseLeave = () => {
        if (isHovered) setIsHovered(false)
    }

    const onDeleteClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        props.onReset && props.onReset()
    }

    const className = Classes("ui5-field-form-element flex-row-between-center not-selectable", "size-"+size, props.className, {
        'is-hovered'        : isHovered || props.children
    })

    const displayValue = props.field.getDisplayValue(props.value)

    const showIcon = _.get(props.options, 'showIcon', true)

    if (isHovered || props.children) {
        return (
            <React.Fragment>
                <div className    = {className}
                     onClick      = {props.onClick}
                     onMouseEnter = {onMouseEnter}
                     onMouseLeave = {onMouseLeave}>

                    <div className="flex-row-left-center txt-truncate">
                        {showIcon && <div className="ui5-ico-16 i5-deadline m-r-10"/>}
                        <div className="ui5-txt-default txt-truncate">{displayValue}</div>
                    </div>

                    <div className="buttons">
                        {props.field.clearButton && <div className="btn-reset" onClick={onDeleteClick}/>}
                        <div className="btn-arrow"/>
                    </div>
                </div>
                {props.children}
            </React.Fragment>
        )
    }

    // not hovered
    return (
        <React.Fragment>
            <div className={Classes(className)}
                 onClick={props.onClick}
                 onMouseEnter={onMouseEnter}
                 onMouseLeave={onMouseLeave}>
                <div className="flex-row-left-center txt-truncate">
                    {showIcon && <div className="ui5-ico-16 i5-deadline m-r-10"></div>}
                    <div className="ui5-txt-default txt-truncate">{displayValue}</div>
                </div>
                <div className="buttons">
                    <div className="btn-arrow"/>
                </div>
            </div>
            {props.children}
        </React.Fragment>
    )

}
